"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScreenReportStepIds = getScreenReportStepIds;
const libs_utils_sanitize_1 = require("libs.utils.sanitize");
const SCREENS_TO_IGNORE = ['review', 'completion'];
/**
 * Step ids used in screen-report `?step=` URLs. Must match the compiled instrument,
 * which keys steps with `sanitizeStringName(screen.identifier)`.
 */
function getScreenReportStepIds(screens) {
    return screens
        .filter((screen) => screen.type == null || !SCREENS_TO_IGNORE.includes(screen.type))
        .map((screen) => (0, libs_utils_sanitize_1.sanitizeStringName)(screen.identifier));
}
//# sourceMappingURL=screen_report_step_ids.js.map